import type { FaireProductEntity } from "../../entity_types/product";

export const p_sngnatw8et: FaireProductEntity = {
  token: "p_sngnatw8et",
  type: "product",
  name: "USB Cool Mist Humidifier with Night Light – Portable",
  brandToken: "b_72ivqmkinu",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5772acc5efbd44afb0cf91abef01a2c3e408aa486f2b6e169d2527950d9c9d46.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/096bd02e2bb41781960e8bd68d017b7111dab43522f1b63711544196b747a900.jpeg",
    "https://cdn.faire.com/fastly/cb0b9e1fc4ae1e76500b26af9c6770d6dbe9918ccade1b0d3b04a3e9d1a59bd1.jpeg",
    "https://cdn.faire.com/fastly/f2f04fa5420809a7548d334f1994a4c8a776e187fac539ebbf427933be94d3f3.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "This USB-powered cool mist humidifier adds moisture to dry spaces while doubling as a soft night light for desks, bedrooms, and travel. Its compact size, quiet operation, and modern pastel design make it an easy giftable wellness and home item.\n\nKey Features\n\nUSB-powered humidifier delivers a cool mist for personal spaces\n\nBuilt-in night light adds a soft ambient glow for bedside or desk use\n\nCompact 250ml capacity is ideal for bedrooms, offices, dorms, and travel\n\nQuiet operation supports everyday use during work, sleep, or relaxation\n\nModern minimalist design comes in soft assorted colors with giftable appeal\n\nGreat for dry rooms, desktop setups, self-care displays, and wellness gifts\n\nPrice on Faire is per Piece; case pack includes 6 pieces. (Not Assorted, Choose your Color.)",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:30.295Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
